export const COMPANIES = [
  { id: 1, key: 'belediye', label: 'Belediye', logo: '/img/isklogo.png', icon: 'fas fa-landmark' },
  { id: 2, key: 'iskent', label: 'İskent', logo: '/img/iskentlogo.png', icon: 'fas fa-building' },
  { id: 3, key: 'aksa', label: 'Aksa', logo: '/img/aksa.png', icon: 'fas fa-fire' },
  { id: 4, key: 'hatsu', label: 'Hatsu', logo: '/img/hatsu.webp', icon: 'fas fa-tint' },
  { id: 5, key: 'enerjisa', label: 'Enerjisa', logo: '/img/enerjisa.png', icon: 'fas fa-bolt' },
  { id: 6, key: 'turktelekom', label: 'Türk Telekom', logo: '/img/turktelekom.svg', icon: 'fas fa-phone' },
  { id: 7, key: 'superonline', label: 'Superonline', logo: '/img/superonline.webp', icon: 'fas fa-wifi' },
  { id: 8, key: 'vodafone', label: 'Vodafone', logo: '/img/vodafone.png', icon: 'fas fa-signal' },
  { id: 9, key: 'muhtarlar', label: 'Muhtarlar', logo: '/img/muhtarlar.png', icon: 'fas fa-user-tie' },
  { id: 11, key: 'buyuksehir', label: 'Büyükşehir', logo: '/img/buyuksehir.png', icon: 'fas fa-landmark' },
  { id: 12, key: 'makinaIkmal', label: 'Makina İkmal', logo: '/img/makineikmal.png', icon: 'fas fa-truck' },
  { id: 13, key: 'fenIsleri', label: 'Fen İşleri', logo: '/img/fen%20isleri.png', icon: 'fas fa-tools' },
  { id: 14, key: 'veliYildirim', label: 'Veli Yıldırım', logo: '/img/veliyildirim.png', icon: 'fas fa-hard-hat' }
];

export const VELI_YILDIRIM_WORK_TYPES = {
  'ÜST YAPI ÇALIŞMASI': [
    'Asfalt Kaplama', 'Asfalt Yama', 'Yol Boyama', 'Kilit Parke',
    'Asfalt Kaldırım', 'Desenli Kaldırım', 'Kaldırım Tadilat', 'Asfalt Kırığı',
    'Aydınlatma Çalışması', 'Açık Hava Reklam', 'Kent Estetiği', 'Otobüs Durağı'
  ],
  'ALTYAPI ÇALIŞMALARI': ['Yağmur Suyu Drenaj Hattı', 'Mazgal Yenileme', 'Mazgal Tadilatı'],
  'BİNA BAKIM-ONARIM ve YENİLEME': [
    'Sosyal Tesisler', 'Kamu Kurumları Destek Çalışmaları', 'Sosyal Belediyecilik Çalışmaları'
  ],
  'ARAÇ, EKİPMAN VE BAKIM ONARIM': ['Yeni Araç Alımı', 'Hibe', 'Araç Üst Yapı']
};

export function getCollaborationCompanyIds(fault) {
  let value = fault?.collaborationCompanyIds ?? fault?.CollaborationCompanyIds ?? [];
  if (typeof value === 'string') {
    try { value = JSON.parse(value); } catch { return []; }
  }
  if (!Array.isArray(value)) return [];
  return [...new Set(value.map(Number).filter(id => COMPANIES.some(company => company.id === id)))];
}

export function collaborationLabels(fault) {
  const ids = getCollaborationCompanyIds(fault);
  return COMPANIES.filter(company => ids.includes(company.id)).map(company => company.label).join(', ');
}

// Company filters are inclusive: ownership and collaboration both match.
// With no explicit selection, retain the panel's visible-company rules.
export function matchesCollaborationSelection(fault, selection = {}, permissions = null) {
  const ids = getCollaborationCompanyIds(fault);
  if (!ids.length) return false;
  const selected = COMPANIES.filter(company => selection?.[company.key]);
  if (selected.length) return selected.some(company => ids.includes(company.id));
  if (!permissions || selection?.insaat || selection?.park) return false;
  return COMPANIES.some(company => ids.includes(company.id)
    && permissions[`canSee${company.key[0].toUpperCase()}${company.key.slice(1)}`]);
}
